// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Admin__AdminsFormController from "./admin/admins_form_controller"
application.register("admin--admins-form", Admin__AdminsFormController)

import Admin__CompaniesFormController from "./admin/companies_form_controller"
application.register("admin--companies-form", Admin__CompaniesFormController)

import Attandances__ClockController from "./attandances/clock_controller"
application.register("attandances--clock", Attandances__ClockController)

import Attandances__ConfirmController from "./attandances/confirm_controller"
application.register("attandances--confirm", Attandances__ConfirmController)

import Attandances__FormController from "./attandances/form_controller"
application.register("attandances--form", Attandances__FormController)

import Attandances__ModeToggleController from "./attandances/mode_toggle_controller"
application.register("attandances--mode-toggle", Attandances__ModeToggleController)

import Attandances__WorkEditController from "./attandances/work_edit_controller"
application.register("attandances--work-edit", Attandances__WorkEditController)

import AttendanceRules__ListController from "./attendance_rules/list_controller"
application.register("attendance-rules--list", AttendanceRules__ListController)

import BonusHourRules__FormController from "./bonus_hour_rules/form_controller"
application.register("bonus-hour-rules--form", BonusHourRules__FormController)

import BonusHourRules__SearchController from "./bonus_hour_rules/search_controller"
application.register("bonus-hour-rules--search", BonusHourRules__SearchController)

import EffectiveAttendanceRules__FormController from "./effective_attendance_rules/form_controller"
application.register("effective-attendance-rules--form", EffectiveAttendanceRules__FormController)

import EffectiveAttendanceRules__ListController from "./effective_attendance_rules/list_controller"
application.register("effective-attendance-rules--list", EffectiveAttendanceRules__ListController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import Performances__ColumnToggleController from "./performances/column_toggle_controller"
application.register("performances--column-toggle", Performances__ColumnToggleController)

import Performances__FilterController from "./performances/filter_controller"
application.register("performances--filter", Performances__FilterController)

import Performances__PerformanceFieldController from "./performances/performance_field_controller"
application.register("performances--performance-field", Performances__PerformanceFieldController)

import Performances__TableController from "./performances/table_controller"
application.register("performances--table", Performances__TableController)

import Projects__ClearFilterController from "./projects/clear_filter_controller"
application.register("projects--clear-filter", Projects__ClearFilterController)

import Projects__ExpandController from "./projects/expand_controller"
application.register("projects--expand", Projects__ExpandController)

import Projects__FormController from "./projects/form_controller"
application.register("projects--form", Projects__FormController)

import ScheduleEntries__CellController from "./schedule_entries/cell_controller"
application.register("schedule-entries--cell", ScheduleEntries__CellController)

import ScheduleEntries__EntryController from "./schedule_entries/entry_controller"
application.register("schedule-entries--entry", ScheduleEntries__EntryController)

import ScheduleEntries__SearchController from "./schedule_entries/search_controller"
application.register("schedule-entries--search", ScheduleEntries__SearchController)

import ScheduleEntries__WeekCalendarController from "./schedule_entries/week_calendar_controller"
application.register("schedule-entries--week-calendar", ScheduleEntries__WeekCalendarController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SharePatterns__FormController from "./share_patterns/form_controller"
application.register("share-patterns--form", SharePatterns__FormController)

import SharePatterns__TableController from "./share_patterns/table_controller"
application.register("share-patterns--table", SharePatterns__TableController)

import SystemSettings__FormController from "./system_settings/form_controller"
application.register("system-settings--form", SystemSettings__FormController)

import SystemSettings__TableController from "./system_settings/table_controller"
application.register("system-settings--table", SystemSettings__TableController)

import Team__BulkCreationController from "./team/bulk_creation_controller"
application.register("team--bulk-creation", Team__BulkCreationController)

import TeamBulkFormController from "./team_bulk_form_controller"
application.register("team-bulk-form", TeamBulkFormController)

import Tools__FormController from "./tools/form_controller"
application.register("tools--form", Tools__FormController)

import Tools__TableController from "./tools/table_controller"
application.register("tools--table", Tools__TableController)

import UnsavedChangesController from "./unsaved_changes_controller"
application.register("unsaved-changes", UnsavedChangesController)

import Users__UserController from "./users/user_controller"
application.register("users--user", Users__UserController)

import VacationPatterns__FormController from "./vacation_patterns/form_controller"
application.register("vacation-patterns--form", VacationPatterns__FormController)

import VacationPatterns__TableController from "./vacation_patterns/table_controller"
application.register("vacation-patterns--table", VacationPatterns__TableController)

import Wages__FormController from "./wages/form_controller"
application.register("wages--form", Wages__FormController)

import Wages__TableController from "./wages/table_controller"
application.register("wages--table", Wages__TableController)

import WorkPerformances__FieldController from "./work_performances/field_controller"
application.register("work-performances--field", WorkPerformances__FieldController)

import WorkPerformances__FilterController from "./work_performances/filter_controller"
application.register("work-performances--filter", WorkPerformances__FilterController)

import WorkPerformances__MatrixController from "./work_performances/matrix_controller"
application.register("work-performances--matrix", WorkPerformances__MatrixController)

import WorkPerformances__ModeController from "./work_performances/mode_controller"
application.register("work-performances--mode", WorkPerformances__ModeController)

import WorkPerformances__SummaryController from "./work_performances/summary_controller"
application.register("work-performances--summary", WorkPerformances__SummaryController)

import WorkPerformances__TableController from "./work_performances/table_controller"
application.register("work-performances--table", WorkPerformances__TableController)

import WorkTypes__FormController from "./work_types/form_controller"
application.register("work-types--form", WorkTypes__FormController)

import WorkTypes__TableController from "./work_types/table_controller"
application.register("work-types--table", WorkTypes__TableController)

import Workers__WorkerController from "./workers/worker_controller"
application.register("workers--worker", Workers__WorkerController)
